// extracted by mini-css-extract-plugin
export default {"select_image":"hero_select_image__05wzr"};